import {
  AUDIENCE_TYPES,
  AUDIENCE_TYPES_ARRAY,
  NARRATIVE_TYPES,
} from "posts/constants";
import Card, { CardTitle } from "./Card";
import React, { useState } from "react";

import CompareModal from "./CompareModal";
import NarrativeCard from "components/NarrativeCard";
import { getAudienceEmoji } from "posts/constants";

function NarrativesCard({ activeAudience }) {
  const [showCompare, setShowCompare] = useState(false);
  const [showNarrativeModal, setShowNarrativeModal] = useState(false);

  const renderContent = (audience, small) => {
    switch (audience) {
      case AUDIENCE_TYPES.TOUGH_COOKIES:
        return (
          <NarrativeCard
            narrative={NARRATIVE_TYPES.HELPING_HANDS}
            showModal={showNarrativeModal}
            setShowModal={setShowNarrativeModal}
            href="/narratives"
            linkText="View all Narratives"
          />
        );
      case AUDIENCE_TYPES.DONT_TREAD_ON_ME:
        return (
          <NarrativeCard
            narrative={NARRATIVE_TYPES.VOTE_FOR_X}
            showModal={showNarrativeModal}
            setShowModal={setShowNarrativeModal}
            href="/narratives"
            linkText="View all Narratives"
          />
        );
      case AUDIENCE_TYPES.PEOPLE_POWER:
        return (
          <NarrativeCard
            narrative={NARRATIVE_TYPES.THE_GRIND}
            showModal={showNarrativeModal}
            setShowModal={setShowNarrativeModal}
            href="/narratives"
            linkText="View all Narratives"
          />
        );
      case AUDIENCE_TYPES.IF_YOU_SAY_SO:
        return (
          <NarrativeCard
            narrative={NARRATIVE_TYPES.EQUITY_GAP}
            showModal={showNarrativeModal}
            setShowModal={setShowNarrativeModal}
            href="/narratives"
            linkText="View all Narratives"
          />
        );
    }
  };

  return (
    <Card>
      <CardTitle
        onCompareClick={() => {
          setShowCompare(true);
        }}
      >
        Distinctive Poverty Narrative
      </CardTitle>
      {renderContent(activeAudience)}
      <CompareModal
        centered
        size="xl"
        show={showCompare}
        onHide={() => {
          setShowCompare(false);
        }}
      >
        <CompareModal.Header closeButton>
          <CompareModal.Title>
            Compare Audiences – Narratives
          </CompareModal.Title>
        </CompareModal.Header>
        <CompareModal.Body>
          <CompareModal.Grid>
            {AUDIENCE_TYPES_ARRAY.map((type, i) => {
              return (
                <CompareModal.GridColumn key={`voices-compare-${i}`}>
                  <CompareModal.GridColumnTitle>
                    {getAudienceEmoji(type)}
                    {type}
                  </CompareModal.GridColumnTitle>
                  <CompareModal.GridColumnContent>
                    {renderContent(type, true)}
                  </CompareModal.GridColumnContent>
                </CompareModal.GridColumn>
              );
            })}
          </CompareModal.Grid>
        </CompareModal.Body>
      </CompareModal>
    </Card>
  );
}

export default NarrativesCard;
